




































































import Vue from "vue";
import SidebarVue from "./components/layout/Sidebar.vue";
import UserProfile from "./components/daily-customer-consent-aggregate/UserProfile.vue";

export default Vue.extend({
  components: {
    "c-sidebar": SidebarVue,
    "c-user": UserProfile
  },

  data() {
    return {
      sidebarOpen: false
    };
  },

  methods: {
    logout() {
      this.$persistency.removeItem("accessToken");
      this.$router.push("/login");
    },

    isLoggedIn() {
      return !!this.$persistency.getItem("accessToken");
    },

    getUserName() {
      if (this.$persistency.getItem("userData") != null) {
        const userData = JSON.parse(localStorage.getItem("userData") ?? "{}");
        return userData.display_name;
      }
    },

    getUserData() {
      if (this.$persistency.getItem("userData") != null) {
        const userData = JSON.parse(localStorage.getItem("userData") ?? "{}");
        return userData;
      }
    }
  }
});
